import {FileService, ArtistService, AlbumService, MediaService} from ".";


function getAllArtist(pagination, search) {
    return ArtistService.getAll(pagination, search)
}

function getAllAlbum(pagination, search) {
    return AlbumService.getAll(pagination, search)
}

function getAllMedia(pagination, search) {
    return MediaService.getAll(pagination, search)
}

function getAllFiles(pagination, search) {
    return FileService.getAll(pagination, search)
}

export const SongDialogService = {
    getAllAlbum,
    getAllArtist,
    getAllMedia,
    getAllFiles
};